import React, { useState } from "react";
import "./flowchart-images.css";
import DigitalImageModal from "./DigitalImageModal";
import { Link } from "react-router-dom";
import EbookForms from "../../EbookForms/EbookForms";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function DigitalisierteHausverwaltung() {
	return (
		<div className="beratung_cont">
			<HelmetProvider>
				<Helmet>
					<title>Digitalisierte Immobilienverwaltung</title>
					<meta
						name="description"
						content="Digitalisierte Immobilienverwaltung"
					/>
					<meta
						name="keywords"
						content="Digitalisierte , Immobilienverwaltung, Saas, Feingeist, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<h1>Die Digitalisierte Immobilienverwaltung</h1>
			<p>
				Wir sehen eine digitalisierte Immobilienverwaltung vor allem mit
				bestmöglich automatisierten und gleichgerichteten Prozessen. Die Basis
				dafür bilden Applikationen, in Zukunft Software-as-a-Service-Lösungen,
				Daten und Schnittstellen.
			</p>
			<p>
				Zudem sollten die IT-Prozesse optimal auf die Ablauf- und
				Aufbauorganisation der Immobilienverwaltung ausgelegt sein. Eine
				komplexe Herausforderung bei dessen Umsetzung wir Sie gerne
				unterstützen.
			</p>
			<p>
				Unsere Landkarte ist die Digitalisierte Immobilienverwaltung. Mit
				unseren
				<a
					className="description-link"
					onClick={(e) => document.getElementById("ebookdownloads").click()}
				>
					Tools
				</a>
				und unseren
				<Link
					className="description-link"
					to="/unternehmen/kooperationspartner"
				>
					Kooperationspartner
				</Link>
				bringen wir Ihre Immobilienverwaltung in kürzester Zeit auf ein neues
				Level.
			</p>
			<p> Ihr Effekt: </p>
			<ul className="typeset-u-list">
				<li>Weniger Kosten</li>
				<li>Mehr Effizienz</li>
				<li>Zufriedene Mitarbeiter</li>
				<li>Zukunftsfähigkeit</li>
			</ul>
			<DigitalImageModal />
			<hr />
			<EbookForms type="ebook" />
			<hr />
		</div>
	);
}
